import './hotspot.css'
import {React, Component, useState, useEffect} from "react";

import Hotspot from './hotspot-annotation-design.js';

/**
 * 
 * @param {*} props 
 * @returns Handles all the Hotspot related logic.
 */
export default function HotspotHandling(props) {

    return(
        // Render all the Hotspots.
        props.hotspots.map((hotspot, idx) => (
            <Hotspot
                bkColor     = {props.bkColor}            // 'display-icon' or ANY COLOR OF CHOICE
                iconType    = 'info'                    // 'info', 'animation' or 'material'
                msg         = {props.msg}
                hotspot     = {hotspot}
                idx         = {idx}
            />
        ))

    );
}